module.exports = __webpack_public_path__ + "static/media/128.f2cfa907.png";